import { useEffect, useRef } from "react";

const SCRIPT_ID = "google-translate-script";
const ELEMENT_ID = "google_translate_element";

export const GoogleTranslate = () => {
  const isInitialized = useRef(false);
  const initTimeout = useRef(null);

  useEffect(() => {
    if (initTimeout.current) {
      clearTimeout(initTimeout.current);
    }

    const initTranslate = () => {
      if (
        !isInitialized.current &&
        window.google?.translate?.TranslateElement
      ) {
        try {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "bs",
              includedLanguages: "en",
              autoDisplay: false,
              layout:
                window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            },
            ELEMENT_ID
          );
          isInitialized.current = true;
        } catch (error) {
          console.error("Failed to initialize Google Translate:", error);
        }
      }
    };

    let script = document.getElementById(SCRIPT_ID);

    if (!script && !isInitialized.current) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;

      window.googleTranslateElementInit = () => {
        initTimeout.current = setTimeout(initTranslate, 100);
      };

      document.head.appendChild(script);
    }

    return () => {
      if (initTimeout.current) {
        clearTimeout(initTimeout.current);
      }
    };
  }, []);

  return <div id={ELEMENT_ID} />;
};
